angular.module('vastdesk').
  component('htmlVideoPlayer',  {
    bindings: {
      playerId: '@',
      src: '@',
      poster: '@',
      clickThruUrl: '@',
      showEnableClickThru: '@'
    },
    template:
        '<div class="html-video-player-wrapper">' +
          '<div class="html-video-player-stage">' +
            '<video id="{{$htmlVideoPlayerCtrl.playerId}}" ' +
                   'class="html-video-player-video" ' +
                   'ng-src="{{$htmlVideoPlayerCtrl.src}}" ' +
                   'ng-attr-poster="{{$htmlVideoPlayerCtrl.poster}}" ' +
                   'ng-attr-controls="{{!$htmlVideoPlayerCtrl.enableClickThru ? \'controls\' : undefined}}" ' +
                   'playsinline></video>' +
            '<a ng-show="$htmlVideoPlayerCtrl.enableClickThru" ' +
               'class="html-video-player-clickthru" ' +
               'href="{{$htmlVideoPlayerCtrl.clickThruUrl}}" ' +
               'target="_blank" rel="noopener noreferrer" ' +
               'title="{{$htmlVideoPlayerCtrl.clickThruUrl}}" ' +
               'aria-label="Click-thru"></a>' +
          '</div>' +
          '<div class="html-video-player-toggles" ng-if="$htmlVideoPlayerCtrl.showEnableClickThru === \'true\'">' +
            '<label class="html-video-player-checkbox-label">' +
              '<input type="checkbox" ng-model="$htmlVideoPlayerCtrl.enableClickThru" ' +
                     'class="html-video-player-checkbox">' +
              'Enable Click Thru' +
            '</label>' +
          '</div>' +
        '</div>',
    controllerAs: '$htmlVideoPlayerCtrl',
    controller: ['$rootScope', '$scope', '$element', function($rootScope, $scope, $element) {

      var self = this;
      var video;

      self.enableClickThru = false;

      var formInput;
      var onLandingPageUrlInput = function() {
        self.clickThruUrl = formInput.value;
        $scope.$applyAsync();
      };

      this.$postLink = function() {
        video = $element[0].querySelector('.html-video-player-video');
        if (self.showEnableClickThru !== 'true') return;
        formInput = document.querySelector('input[name*="creative_landing_page_url"]');
        if (formInput) {
          formInput.addEventListener('input', onLandingPageUrlInput);
        }
      };

      $rootScope.$on('videoChange', function(e, args) {
        if (args.playerId === self.playerId) {
          self.src = args.src;
          self.poster = args.poster;
          if (Object.prototype.hasOwnProperty.call(args, 'clickThruUrl')) {
            self.clickThruUrl = args.clickThruUrl;
          }
          self.enableClickThru = false;
          if (video) {
            video.load();
          }
        }
      });

      this.$onDestroy = function() {
        video = null;
        if (formInput) {
          formInput.removeEventListener('input', onLandingPageUrlInput);
        }
      };

    }]
  });

